<!--账号管理-->
<template>
    <div class="container">
        <div class="handleBox flex flex-c flex-b">
            <p class="navTitle">账号管理 ></p>
            <!-- <el-input placeholder="姓名/用户名" v-model="selectValue" size="small" class="input-with-select" style="width:300px">
                <el-button slot="append" icon="el-icon-search" @click="curr=1;getList()"></el-button>
            </el-input> -->
            <div></div>
            <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="addDialog" >添加账号</el-button>
        </div>
        <div class="table" style="height:calc( 100% - 100px )">
            <el-table :data="list" border :header-cell-style="{background:'#fafdff',color:'#606266',fontWeight:'normal'}" height="calc( 100% - 120px )">
                <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="username" label="用户名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="success" size="small" plain @click="editDialog(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small" plain @click="del(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging">
                <el-pagination @current-change="currChange" @size-change="sizeChange" :current-page="curr"
                    :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>

        <!--编辑-->
        <el-dialog :visible="dialogOpen" :title="dialogTitle" :close-on-click-modal="false" width="600px"  @close=" closeDialog " :append-to-body="true" :destroy-on-close="true">
            <div class="editBox">
                <el-form ref="edit" :model="formData" :rules="formRules" @submit.native.prevent label-width="70px">
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="formData.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="formData.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码"  :prop="editPwd ? '' : 'password'">
                        <el-input v-model="formData.password" placeholder="请输入密码(如无需修改留空即可)" show-password autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="editBtn">
                <el-button type="primary" size="small" @click="submit()">保存</el-button>
                <el-button size="small" @click="closeDialog">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'Home',
        data: function () {
            return {
                curr: 1,
                row: 10,
                count: 0,
                pages: 1, //总页数
                dialogOpen: false,
                editPwd:false,
                // selectValue: '',
                dialogTitle: '添加账号',
                formData: {
                    password:'',
                    name: '',
                    username: ''
                },
                list: [],
                // 表单验证
                formRules: {
                    name: [{
                        required: true,
                        message: '请输入姓名',
                        trigger: 'change'
                    }],
                    username: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'change'
                    }],
                    password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'change'
                    }]
                },
                
            }
        },
        mounted: function () {
            this.getList()
        },
        methods: {
            getList: function () {
                this.http.post('/admin/getList', {
                    row: this.row,
                    curr: this.curr,
                    date: this.seachTime
                }).then(res => {
                    this.list = res.list
                    this.curr = res.curr;
                    this.pages = res.pages;
                    this.count = res.count;
                })
            },    
            addDialog:function(){
                this.editPwd = false
                this.formData = {}
                this.dialogOpen = true
                this.dialogTitle = '添加账号'
            },        
            //编辑账号
            editDialog(data) {
                this.editPwd = true
                this.dialogTitle = '编辑账号'
                this.dialogOpen = true
                var form = JSON.stringify(data)
                this.formData = JSON.parse(form)
                this.formData.password = ''
            },

            //删除账号
            del: function (id) {
                this.$confirm('确定要删除吗?', '提示').then(() => {
                    this.http.post('/admin/delete', {
                        id: id
                    }).then(res => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                }).catch(() => {
                    this.$message.info('已取消删除')
                });
            },

            //关闭弹窗
            closeDialog: function () {
                this.dialogOpen = false

                this.$refs['edit'].resetFields();
            },

            //提交
            submit: function () {
                this.$refs['edit'].validate((valid) => {
                    if (valid) {
                        var pwd = this.formData.password ? this.$md5(this.formData.password) : this.formData.password
                        this.http.post('/admin/edit',{
                            id:this.formData.id ? this.formData.id : '',
                            name:this.formData.name,
                            username:this.formData.username,
                            password: pwd
                        }).then(res=>{
                            this.$message.success('保存成功')
                            this.dialogOpen = false
                            this.getList()
                        })
                    }
                })
            },
            currChange: function (curr) {
                this.curr = curr;
                this.getList()
            },
            sizeChange: function (row) {
                this.row = row;
                this.getList()
            },
        }
    }
</script>